import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { returnsIntakeHeadersColumns } from '../config';
import { ReturnsIntakeByDriver } from '../models';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { useSortableData } from '@/hooks';
import { Table } from '@/components';

type ReturnsIntakeTableProps = {
  returnsIntakes: ReturnsIntakeByDriver[];
  isLoading: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

const ReturnsIntakeTable = ({
  returnsIntakes,
  isLoading,
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: ReturnsIntakeTableProps) => {
  const navigate = useNavigate();
  const columns = returnsIntakeHeadersColumns;

  const { sortedData, handleSort, selectedSort } = useSortableData({
    data: returnsIntakes || [],
    currentPage,
  });

  const renderActions = (rowData: ReturnsIntakeByDriver) => {
    const path = rowData.closedAt
      ? `/business/returns-intake/by-driver/${rowData.driverId}?closedAt=${encodeURIComponent(rowData.closedAt)}`
      : `/business/returns-intake/by-driver/${rowData.driverId}`;

    return (
      <IconButton onClick={() => navigate(path)} size='small'>
        <VisibilityIcon fontSize='small' />
      </IconButton>
    );
  };

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5'>
      {returnsIntakes?.length > 0 || isLoading ? (
        <Table
          columns={columns}
          data={sortedData}
          renderActions={renderActions}
          isLoading={isLoading}
          handleSort={handleSort}
          selectedSort={selectedSort}
          pagination={{
            totalItems,
            totalPages,
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: onPageChange,
            onRowsPerPageChange: onPageSizeChange,
          }}
        />
      ) : (
        <span className='text-gray-500 text-sm italic text-center py-10'>
          No se han encontrado rendiciones con los criterios actuales.
        </span>
      )}
    </div>
  );
};

export default ReturnsIntakeTable;
